export default __webpack_public_path__ + "static/media/icon-coin-degen.9dc23ad5.svg";